const MusicaEmEsperaHome = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-musicaespera" */ '../_views/MusicaEmEsperaHome')
const CadastroMusicaEmEspera = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-musicaespera" */ '../_views/CadastroMusicaEmEspera')
const AtualizarMusicaEmEspera = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-musicaespera" */ '../_views/AtualizarMusicaEmEspera')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'espera',
    component: MusicaEmEsperaHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Espera',
  },
  {
    path: 'espera/criar',
    component: CadastroMusicaEmEspera,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Espera/criar',
  },
  {
    path: 'espera/atualizar/:_id',
    component: AtualizarMusicaEmEspera,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Espera/atualizar',
    props: true,
  },
]
